<app-blog-shell [blogId]="'cube-portfolio'" [darkMode]="darkMode">
  <div #entryRoot class="blog-entry">
    <h1 data-translate="BLOG.DETAILS.cube-portfolio.TITLE"></h1>
    <br>

    <p data-translate="BLOG.DETAILS.cube-portfolio.INTRO.P1"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.INTRO.P2"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.INTRO.P3"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.cube-portfolio.TLDR.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.cube-portfolio.TLDR.BODY"></p>
    <br>
    <ul>
      <li data-translate="BLOG.DETAILS.cube-portfolio.TLDR.LI1"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.TLDR.LI2"></li>
    </ul>
    <br>
    <p data-translate="BLOG.DETAILS.cube-portfolio.TLDR.INSPIRATION"></p>

    <br><br>
    <h2 data-translate="BLOG.DETAILS.cube-portfolio.SECTION1.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION1.INTRO"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.cube-portfolio.SECTION1.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.SECTION1.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.SECTION1.ITEM3"></li>
    </ul>

    <pre>
      <code>
        navigateTo(route: string, index: number) &#123;
          if (this.isAnimating || this.activeIndex === index || this.isLocked) return;
          this.isAnimating = true;
          this.activeIndex = index;
          this.cubeService.setActiveFace(index);
          setTimeout(() =&gt; this.isAnimating = false, 2000);
        &#125;
      </code>
    </pre>

    <h2 data-translate="BLOG.DETAILS.cube-portfolio.SECTION2.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION2.P1"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION2.P2"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION2.P3"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION2.P4"></p>

    <br>
    <h3 data-translate="BLOG.DETAILS.cube-portfolio.SECTION3.HEADLINE"></h3>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION3.P1"></p>
    <pre ngNonBindable>
      <code class="language-html">
        &lt;nav #dock class=&quot;nav&quot;&gt;
          &lt;ul class=&quot;nav-list&quot;&gt;
            &lt;li
              *ngFor=&quot;let item of navItems; let i = index&quot;
              [class.active]=&quot;activeIndex === i&quot;
              [class.disabled]=&quot;isLocked&quot;
              (click)=&quot;navigateTo(item.route, i)&quot;
            &gt;
              &lt;i [class]=&quot;item.icon&quot;&gt;&lt;/i&gt;
              &lt;span class=&quot;tooltip&quot;&gt;&#123;&#123; item.tooltip &#125;&#125;&lt;/span&gt;
            &lt;/li&gt;
          &lt;/ul&gt;
        &lt;/nav&gt;
      </code>
    </pre>

    <h4 data-translate="BLOG.DETAILS.cube-portfolio.SECTION4.HEADLINE"></h4>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION4.P1"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.cube-portfolio.SECTION4.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.SECTION4.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.SECTION4.ITEM3"></li>
    </ul>

    <br>
    <h2 data-translate="BLOG.DETAILS.cube-portfolio.SECTION5.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION5.P1"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION5.P2"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION5.P3"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION5.P4"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.cube-portfolio.SECTION6.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION6.P1"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.SECTION6.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.P1"></p>
    <p data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.P2"></p>
    <br>
    <p data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.SUITABLE"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.LI1"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.LI2"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.LI3"></li>
    </ul>
    <br>
    <p data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.UNSUITABLE"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.LI4"></li>
      <li data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.LI5"></li>
    </ul>
    <br>
    <p data-translate="BLOG.DETAILS.cube-portfolio.CONCLUSION.P3"></p>
  </div>
  <br>
</app-blog-shell>
